module.exports = __webpack_public_path__ + "46b72d5bc32d4eee4d372c0ed74344f6.png";